/**
 * パターン紐付けモーダル
 */

import { useState } from "react";
import { Modal, Stack, Text, Select, Group, Button } from "@mantine/core";
import { Partner, PartnerPattern } from "../../services/partnerService";

interface PatternMapModalProps {
  opened: boolean;
  onClose: () => void;
  pattern: PartnerPattern | null;
  partners: Partner[];
  onMap: (patternId: string, partnerId: string) => Promise<void>;
}

/**
 * パターン紐付けモーダル
 */
export function PatternMapModal({
  opened,
  onClose,
  pattern,
  partners,
  onMap,
}: PatternMapModalProps) {
  const [mappingPartnerId, setMappingPartnerId] = useState<string | null>(null);

  const handleMap = async () => {
    if (!pattern || !mappingPartnerId) return;
    await onMap(pattern.id, mappingPartnerId);
    setMappingPartnerId(null);
    onClose();
  };

  const handleClose = () => {
    setMappingPartnerId(null);
    onClose();
  };

  return (
    <Modal opened={opened} onClose={handleClose} title="パターンを取引先に紐付け">
      <Stack>
        <Text>
          パターン: <strong>&quot;{pattern?.pattern}&quot;</strong>
        </Text>
        <Select
          label="紐付ける取引先"
          placeholder="取引先を選択"
          data={partners.map((p) => ({
            value: p.id,
            label: p.officialName,
          }))}
          value={mappingPartnerId}
          onChange={setMappingPartnerId}
          searchable
        />
        <Group justify="flex-end">
          <Button variant="default" onClick={handleClose}>
            キャンセル
          </Button>
          <Button onClick={handleMap} disabled={!mappingPartnerId}>
            紐付け
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
